<template>
    <TextControl
        :name
        :class="$props.class"
        :error-message
        :placeholder
        :disabled
        :type
        :label
        :readonly
        :inputClass
        v-model="value">
        <template v-if="$slots.icon" #icon>
            <slot name="icon"></slot>
        </template>
    </TextControl>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import TextControl from './TextControl.vue'
import type { CommonProps } from './types'
import { toRef } from 'vue'

interface Props {
    name: string
    inputClass?: string
}

const props = defineProps<CommonProps & Props>()

const { errorMessage, value } = useField<string>(toRef(props, 'name'))
</script>

<style scoped></style>
